import { render, staticRenderFns } from "./RuleCollectionBuilder.vue?vue&type=template&id=16f74e3d"
import script from "./RuleCollectionBuilder.vue?vue&type=script&lang=js"
export * from "./RuleCollectionBuilder.vue?vue&type=script&lang=js"
import style0 from "../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RuleCollectionBuilder.vue?vue&type=style&index=1&id=16f74e3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports